/*
  Feelair sticky mobile add-to-cart bar (2026-10-06).
  Markup: snippets/product-sticky-atc.liquid. Styles: assets/fa-sticky-atc.css.

  The bar never owns any product logic. It drives the theme's own controls:
    - picking a variant sets the main picker's inputs ([data-variant-input]) and dispatches `change`,
      which runs theme.Variants._onSelectChange (assets/theme.js) exactly like a real tap: price, media,
      ?variant= URL, Recharge widget, main button state all follow;
    - the main picker changing fires `variantChange` on the product section, and the bar re-reads the
      picker's checked inputs;
    - the bar's button clicks the main [data-add-to-cart] button, so the theme's AjaxProduct submit
      (selling plan, quantity, cart drawer) runs unchanged.

  Visible only on mobile (<768px) and only once the main add-to-cart button has scrolled above the screen.
*/
(function () {
  'use strict';

  var MOBILE = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  var root = document.documentElement;

  function isMobile() {
    return MOBILE ? MOBILE.matches : false;
  }

  function init(bar) {
    if (bar.hasAttribute('data-fa-ready')) return;

    var formId = bar.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : null;
    var mainBtn = form ? form.querySelector('[data-add-to-cart]') : null;
    if (!form || !mainBtn) return;

    var section = form.closest('[data-section-type="product"]') || document;
    var mainBtnText = mainBtn.querySelector('[data-add-to-cart-text]');

    var select = bar.querySelector('[data-fa-sticky-select]');
    var titleEl = bar.querySelector('[data-fa-sticky-title]');
    var metaEl = bar.querySelector('[data-fa-sticky-meta]');
    var btn = bar.querySelector('[data-fa-sticky-btn]');
    var btnText = bar.querySelector('[data-fa-sticky-btn-text]');

    // A section reload in the theme editor renders a fresh bar; drop the one that was moved to <body>.
    document.querySelectorAll('[data-fa-sticky-atc][data-form-id="' + formId + '"]').forEach(function (old) {
      if (old !== bar) old.remove();
    });

    // Variants, read from the options Liquid rendered: [{ id, options: [..], el }].
    var variants = [];
    if (select) {
      select.querySelectorAll('option').forEach(function (opt) {
        var options = [];
        try {
          options = JSON.parse(opt.getAttribute('data-options') || '[]');
        } catch (e) {
          options = [];
        }
        variants.push({ id: opt.value, options: options, el: opt });
      });
    }

    // ---- Variant: main picker <-> bar ------------------------------------------------------------

    function optionPosition(el) {
      // data-index is "option1".."option3"
      return parseInt(String(el.getAttribute('data-index')).slice(-1), 10) - 1;
    }

    function mainInputs() {
      return Array.prototype.slice.call(section.querySelectorAll('[data-variant-input]'));
    }

    function checkedValues() {
      var values = [];
      mainInputs().forEach(function (el) {
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
        values[optionPosition(el)] = el.value;
      });
      return values;
    }

    function variantFromMain() {
      var values = checkedValues();
      if (!values.length) {
        // No variant picker on this template: the form's own id field is the source of truth.
        var master = section.querySelector('[data-product-select]');
        for (var k = 0; master && k < variants.length; k++) {
          if (variants[k].id === master.value) return variants[k];
        }
        return null;
      }
      for (var i = 0; i < variants.length; i++) {
        var options = variants[i].options;
        var match = options.length === values.length;
        for (var j = 0; match && j < options.length; j++) {
          if (options[j] !== values[j]) match = false;
        }
        if (match) return variants[i];
      }
      return null;
    }

    function paint(variant) {
      if (!titleEl || !metaEl) return;
      if (variant) {
        titleEl.textContent = variant.el.getAttribute('data-title') || '';
        metaEl.textContent = variant.el.getAttribute('data-meta') || '';
      } else {
        // The combination does not exist: show what the main button shows ("Utilgængelig").
        titleEl.textContent = mainBtnText ? mainBtnText.textContent.trim() : '';
        metaEl.textContent = '';
      }
    }

    function syncFromMain() {
      if (!select) return;
      var variant = variantFromMain();
      if (variant) select.value = variant.id;
      paint(variant);
    }

    function driveMain(id) {
      var target = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === String(id)) target = variants[i];
      }
      if (!target) return;

      var inputs = mainInputs();
      var changed = null;

      if (inputs.length) {
        inputs.forEach(function (el) {
          var wanted = target.options[optionPosition(el)];
          if (el.type === 'radio' || el.type === 'checkbox') {
            var shouldBeChecked = el.value === wanted;
            if (shouldBeChecked && !el.checked) changed = el;
            el.checked = shouldBeChecked;
          } else if (el.value !== wanted) {
            el.value = wanted;
            changed = el;
          }
        });
      } else {
        // No variant picker on this template: set the form's own id field instead.
        var master = section.querySelector('[data-product-select]');
        if (master && master.value !== String(id)) {
          master.value = String(id);
          changed = master;
        }
      }

      // Same event a real tap on the picker produces; theme.Variants listens for it on each input.
      if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));

      // Whatever the theme settled on (it may pick the closest available variant) wins.
      syncFromMain();
    }

    if (select) {
      select.addEventListener('change', function () {
        driveMain(select.value);
      });
    }

    section.addEventListener('variantChange', syncFromMain);
    window.addEventListener('pageshow', function (evt) {
      if (evt.persisted) syncFromMain();
    });

    // ---- Button: mirrors and clicks the main add-to-cart button ----------------------------------

    function syncButton() {
      var disabled = mainBtn.disabled || mainBtn.classList.contains('disabled');
      btn.disabled = disabled;
      var label = (mainBtnText || mainBtn).textContent.replace(/\s+/g, ' ').trim();
      if (label && btnText.textContent !== label) btnText.textContent = label;
      var loading = mainBtn.classList.contains('btn--loading');
      btn.classList.toggle('is-loading', loading);
      if (loading) btn.setAttribute('aria-busy', 'true');
      else btn.removeAttribute('aria-busy');
    }

    btn.addEventListener('click', function () {
      if (mainBtn.disabled) return;
      mainBtn.click();
    });

    if (window.MutationObserver) {
      var observer = new MutationObserver(syncButton);
      observer.observe(mainBtn, { attributes: true, attributeFilter: ['disabled', 'class'] });
      if (mainBtnText) {
        observer.observe(mainBtnText, { childList: true, characterData: true, subtree: true });
      }
    }

    // ---- Visibility -----------------------------------------------------------------------------

    var pastMainButton = false;
    var shown = false;

    function render() {
      var show = pastMainButton && isMobile();
      if (show === shown) return;
      shown = show;
      bar.hidden = !show;
      if (show) bar.removeAttribute('inert');
      else bar.setAttribute('inert', '');
      root.classList.toggle('has-sticky-atc', show);
    }

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        var entry = entries[entries.length - 1];
        // Shown only once the main button has gone off the TOP of the screen. Not while it (or the
        // variant picker above it) is on screen, and not while it is still below the screen.
        pastMainButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        render();
      }).observe(mainBtn);

      // An IntersectionObserver only reports when the button starts or stops intersecting. A fast
      // fling, a "back to top" jump or scroll restoration can carry the page from "button above the
      // screen" to "button below the screen" without a single frame in between, and then no callback
      // fires and the bar would stay up at the top of the page. Re-check once per frame while scrolling.
      var frame = 0;
      var recheck = function () {
        frame = 0;
        var rect = mainBtn.getBoundingClientRect();
        var past = rect.bottom < 0;
        if (past !== pastMainButton) {
          pastMainButton = past;
          render();
        }
      };
      window.addEventListener(
        'scroll',
        function () {
          if (!frame) frame = window.requestAnimationFrame(recheck);
        },
        { passive: true }
      );
    }

    if (MOBILE) {
      if (MOBILE.addEventListener) MOBILE.addEventListener('change', render);
      else if (MOBILE.addListener) MOBILE.addListener(render);
    }

    // Expose the bar height so the signup popup teaser can sit above it (see fa-sticky-atc.css).
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        var height = bar.offsetHeight;
        if (height) root.style.setProperty('--fa-sticky-atc-h', height + 'px');
      }).observe(bar);
    }

    // ---- Go -------------------------------------------------------------------------------------

    // Straight under <body>: no ancestor transform, overflow or stacking context from a page section
    // can clip the fixed bar or paint another section over it.
    if (bar.parentNode !== document.body) document.body.appendChild(bar);

    bar.setAttribute('data-fa-ready', '');
    syncButton();
    syncFromMain();
  }

  function initAll() {
    document.querySelectorAll('[data-fa-sticky-atc]:not([data-fa-ready])').forEach(init);
  }

  initAll();
  // Theme editor: a reloaded product section brings a new bar.
  document.addEventListener('shopify:section:load', initAll);
})();
